<template>
  <div>
    <div class="product-list">
      <div class="title">
        <h4>{{title}}</h4>
        <span @click="$router.push('/category')">
          更多
          <img src="../assets/images/right.png" alt />
        </span>
      </div>
      <ul>
        <li @click="toProductDetails(item)" v-for="(item,index) in productList" :key="index">
          <div class="product-img">
            <img :src="item.imgAddress" alt />
          </div>
          <p class="brand">{{item.model}}</p>
          <p class="price">￥{{item.price}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "product",
  data() {
    return {};
  },
  props: {
    productList: Array,
    title: String
  },
  methods: {
    toProductDetails(item) {
      this.$router.push({
        name: "productDetails",
        query:{
            productId:item.stockId
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.product-list {
  background: #fff;
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  margin-top: 20px;
  .title {
    h4 {
      color: #2e2e2e;
      font-size: 32px;
      display: inline-block;
    }
  }
  span {
    color: #999;
    font-size: 26px;
    float: right;
    img {
      height: 22px;
      margin-left: 5px;
    }
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 217px;
      height: 316px;
      border: 1px solid #f2f2f2;
      margin: 20px 13px 0 0;
      font-size: 26px;
      .product-img {
        width: 170px;
        height: 170px;
        margin: 0 auto;
        margin-top: 23px;
        overflow: hidden;
        position: relative;
        img {
          max-width: 100%;
          max-height: 100%;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .brand {
        margin: 0 auto;
        color: #a8a8a8;
        width: 197px;
        overflow: hidden;
        margin-top: 32px;
        white-space: nowrap;
      }
      .price {
        text-align: center;
        color: #ff6600;
        margin-top: 15px;
      }
    }
    li:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>